import * as Puppeteer from 'puppeteer';

export async function getPageURL(page: Puppeteer.Page): Promise<string> {
  const location = await page.evaluate(() => document.location.href);
  return location;
}

export async function getPageTitle(page: Puppeteer.Page): Promise<string> {
  const title = await page.evaluate(() => document.title);
  return title;
}

export async function IsElementVisible(page: Puppeteer.Page, identifier: string): Promise<boolean> {
  try {
    await page.waitFor(identifier, { visible: true });
    return true;
  } catch (err) {
    await console.log(err);
  }
  return false;
}

export async function IsElementDisabled(
  page: Puppeteer.Page,
  identifier: string
): Promise<boolean> {
  try {
    const element = await page.waitFor(identifier, { timeout: 3000 });
    const innerText = (await (await element.getProperty('innerText')).jsonValue()) as string;
    console.log('HOW COME' + innerText + identifier);
    //const isDisabled = await page.$eval(identifier, el => el.disabled );
    //console.log('++++++++++++++++++++'+isDisabled);
    return (await (await element.getProperty('disagbled')).jsonValue()) as boolean;
  } catch (err) {
    console.log(err);
  }
  return false;
}

export const getElement = async (page: Puppeteer.Page, identifier: string): Promise<any> => {
  try {
    const element = await page.waitFor(identifier, { timeout: 3000 });
    return element;
  } catch (e) {
    console.log('error : ', e);
  }
};
